/**
 * Pré-validation client des fichiers joints — MIROIR STRICT du backend T4
 * (CreateMessageRequest : max 5 fichiers, 10 MB chacun, whitelist mime).
 * Le rejet est immédiat, sans round-trip; le backend reste l'autorité (finfo).
 */

export const CHAT_UPLOAD_MAX_FILES = 5;
export const CHAT_UPLOAD_MAX_BYTES = 10 * 1024 * 1024; // 10 MB

export const CHAT_UPLOAD_ACCEPTED_MIMES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/csv',
  'text/plain',
  'application/zip',
];

export type ChatUploadError = 'too_many' | 'too_big' | 'bad_type' | null;

export interface ChatUploadValidation {
  accepted: File[];
  error: ChatUploadError;
  offender?: string; // nom du fichier fautif
}

export function validateChatFiles(existing: File[], incoming: File[]): ChatUploadValidation {
  if (existing.length + incoming.length > CHAT_UPLOAD_MAX_FILES) {
    return { accepted: existing, error: 'too_many' };
  }

  for (const file of incoming) {
    if (file.size > CHAT_UPLOAD_MAX_BYTES) {
      return { accepted: existing, error: 'too_big', offender: file.name };
    }
    if (!CHAT_UPLOAD_ACCEPTED_MIMES.includes(file.type)) {
      return { accepted: existing, error: 'bad_type', offender: file.name };
    }
  }

  return { accepted: [...existing, ...incoming], error: null };
}

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} o`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} Ko`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}
